import { callApi, Controller } from './useApi';

interface AusgabeFibuResult {
    anzahlRechnungen: number;
    anzahlKunden: number;
}

export async function runAusgabeFibu(): Promise<AusgabeFibuResult> {
    return callApi<AusgabeFibuResult>(Controller.bmd + '/ausgabeFibu', {});
}

interface EinlesenFibuResult {
    anzahlRechnungenOffen: number;
    anzahlRechnungenBezahlt: number;
    rechnungenNotFound: string[];
}

export async function runEinlesenFibu(): Promise<EinlesenFibuResult> {
    return callApi<EinlesenFibuResult>(Controller.bmd + '/einlesenFibu', {});
}
